import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * PrelineLoader component
 *
 * Dynamically loads and initializes Preline UI components on route changes.
 * This ensures that Preline's JavaScript-powered components (dropdowns, modals, etc.)
 * work correctly in a SPA after navigation.
 *
 * Usage: Add <PrelineLoader /> to your layout components
 *
 * Based on official Preline documentation:
 * https://preline.co/docs/frameworks-react-vite.html
 */

export function PrelineLoader() {
  const location = useLocation();

  useEffect(() => {
    const initPreline = async () => {
      try {
        await import('preline/dist/index.js');

        // Wait a bit for Preline to register
        await new Promise(resolve => setTimeout(resolve, 100));

        if (window.HSStaticMethods) {
          if (typeof window.HSStaticMethods.autoInit === 'function') {
            window.HSStaticMethods.autoInit();
          } else {
            console.error('[Preline] autoInit is not a function');
          }
        } else {
          console.error('[Preline] HSStaticMethods not found on window');
        }
      } catch (error) {
        console.error('[Preline] Error loading or initializing:', error);
      }
    };

    initPreline();
  }, [location.pathname]);

  return null;
}
